import { render, staticRenderFns } from "./UnverefiedDrivers.vue?vue&type=template&id=b12c6f2a&"
import script from "./UnverefiedDrivers.vue?vue&type=script&lang=js&"
export * from "./UnverefiedDrivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports